<template>
  <popup-right
    title="Paket Ayarları"
    :isPopupVisible="isPopupVisible"
    @close="setDefaultValues"
  >
    <div class="package-settings">
      <div class="package-settings__top m-flex m-items-center">
        <div class="package-settings__image">
          <img
            v-if="dataItem"
            alt="product image"
            :src="
              dataItem.application != null
                ? dataItem.application.imageUrl
                : dataItem.imageUrl
            "
          />
          <base-icon v-else name="no-image" />
        </div>
        <div class="package-settings__info">
          <h3 v-if="dataItem.productName">{{ dataItem.productName }}</h3>
          <p class="package-settings__info-platform">
            <span
              v-if="
                dataItem.application.applicationId == 3 ||
                dataItem.application.applicationId == 2
              "
            >
              {{ dataItem.application.shortContent }}
            </span>
            <span v-else>
              {{ dataItem.platform.name }}
            </span>
          </p>
        </div>
      </div>
      <span
        class="warning-messages"
        v-if="
          dataItem.dateSelection == 1 &&
          startDateSelection == 0 &&
          this.$route.name !== 'Checkout'
        "
      >
        <span class="error-icon">!</span> Paketinizi tüm lisanslarıyla birlikte
        bugün başlayacak şekilde güncelliyorsunuz!
      </span>
      <div class="package-settings__lisans">
        <div class="package-settings__lisans__information">
          <h5 id="lisans">Lisans Bilgileri</h5>
          <div class="market-table">
            <table
              class="table"
              :class="esube === 'yes' ? 'setHeight' : ''"
              v-if="marketInfo"
              aria-describedby="lisans"
            >
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col" class="text-left">Piyasa</th>
                  <th scope="col" class="text-left">Derinlik</th>
                  <th scope="col" class="text-left">Aracı Kurum Dağılımı</th>
                  <th scope="col" class="text-left">Başlangıç Zamanı</th>
                </tr>
              </thead>
              <tbody v-if="!isResponsive">
                <package-setting-type
                  :key="item.id"
                  v-for="item in marketInfo"
                  :item="item"
                  :dataItem="dataItem"
                  :selectData="selectData"
                  :isResponsive="false"
                  @update="changeSelected"
                  @showSpesificWarning="checkSpesificWarning"
                />
              </tbody>
            </table>
          </div>
          <div v-if="isResponsive" class="market-table-responsive">
            <package-setting-type
              :key="item.id"
              v-for="item in marketInfo"
              :item="item"
              :dataItem="dataItem"
              :selectData="selectData"
              :isResponsive="true"
              @update="changeSelected"
              @showSpesificWarning="checkSpesificWarning"
            />
          </div>

          <div class="info-container" v-if="warningMessage">
            <info-area :infoText="infoText[1]" :typeWarning="true"></info-area>
          </div>
        </div>

        <div class="accordion-container">
          <div
            v-if="
              research.length > 0 &&
              research[0].details &&
              research[0].details.length > 0 &&
              showResearch.length > 0
            "
          >
            <accordion-research
              id="accordion-research"
              :content="research"
              :dataItem="dataItem"
            />
          </div>
          <div
            v-if="
              foreign.length > 0 &&
              foreign[0].details &&
              foreign[0].details.length > 0 &&
              showForeign.length > 0
            "
          >
            <accordion-foreign
              id="accordion-foreign"
              :content="foreign"
              :dataItem="dataItem"
            />
          </div>
          <div
            v-if="
              algoServer.length > 0 &&
              algoServer[0].details &&
              algoServer[0].details.length > 0 &&
              showAlgos.length > 0 &&
              Products.name.MatriksIQ == dataItem.application.applicationId
            "
          >
            <Maccordion-algo-server
              id="m-accordion-algo-server"
              :content.sync="algoServer"
              :dataItem="dataItem"
              @changeTriggered="setPropsForAlgoServer($event)"
            />
          </div>
          <div
            v-else-if="
              algoServer.length > 0 &&
              algoServer[0].details &&
              algoServer[0].details.length > 0 &&
              showAlgos.length > 0 &&
              Products.name.MatriksIQ != dataItem.application.applicationId
            "
          >
            <accordion-algo-server
              id="accordion-algo-server"
              :content.sync="algoServer"
              :dataItem="dataItem"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="package-settings__bottom m-flex m-items-center">
      <div class="package-settings__bottom-right">
        <p>
          <span class="m-text-grayscale-80">BES / Yatırım Fonu:</span>
          {{
            formatPrice(
              bottomFund + researchFund + foreignFund + algoServerFund
            )
          }}
          TL
        </p>
        <p>
          <span class="m-text-grayscale-80">Komisyon:</span>
          {{
            formatPrice(
              bottomCommission +
                researchCommission +
                foreignCommission +
                algoServerCommission
            )
          }}
          TL
        </p>
      </div>

      <div class="package-settings__bottom-left">
        <div class="package-settings__price m-flex">
          <span>Toplam Tutar:</span>
          <h2>
            {{
              formatPrice(
                totalPrice +
                  researchTotal +
                  algoServerTotal +
                  foraignTurkishLiraTotal
              )
            }}
            TL&nbsp;
          </h2>
          <h2
            v-if="
              foreign.length > 0 &&
              foreign[0].details &&
              foreign[0].details.length > 0
            "
          >
            {{
              foraignDollarTotal > 0
                ? `+ ${formatPriceDollar(foraignDollarTotal)} USD`
                : ""
            }}
            {{
              foraignEuroTotal > 0
                ? `+ ${formatPriceEuro(foraignEuroTotal)} EUR`
                : ""
            }}
          </h2>
        </div>
        <div class="package-settings__bottom-action m-flex m-items-center">
          <base-button
            id="edit-submit-btn"
            @click="submitShow"
            :class="{ 'button-disabled': isButtonClicked }"
            >Onayla</base-button
          >
        </div>
      </div>
    </div>
    <div class="info-container">
      <info-area :infoText="infoText[0]" :typeWarning="true"></info-area>
    </div>
  </popup-right>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import PackageSettingType from "./PackageSettingType.vue";
import {
  PopupRight,
  BaseButton,
  AccordionResearch,
  BaseIcon,
  AccordionForeign,
  AccordionAlgoServer,
} from "@/components";
import MaccordionAlgoServer from "../base/MaccordionAlgoServer.vue";
import mixins from "../../mixins/";
import InfoArea from "../base/InfoArea.vue";
import { CurrencySymbol } from "../../constants";
import { getItem } from "../../utils/tokenTools";

export default {
  name: "PackageSettigns",
  mixins: [mixins],
  components: {
    BaseButton,
    BaseIcon,
    PopupRight,
    PackageSettingType,
    AccordionResearch,
    AccordionForeign,
    AccordionAlgoServer,
    MaccordionAlgoServer,
    InfoArea,
  },
  props: {
    dataItem: Object,
    marketInfo: Array,
    isPopupVisible: Boolean,
  },
  data() {
    return {
      isResponsive: false,
      fund: 0,
      commission: 0,
      topPrice: 0,
      bottomFund: 0,
      bottomCommission: 0,
      totalPrice: 0,
      startDateSelection: this.dataItem.dateSelection,
      selectData: [],
      updatedList: [],
      research: [],
      foreign: [],
      algoServer: [],
      isButtonClicked: false,
      warningMessage: false,
      esube: getItem("esube"),
      infoText: [
        "Komisyon ya da BES/FON büyüklük şartı sağlanması halinde, ilgili ay için belirtilen veri lisans ücreti alınmayacaktır.",
        "Karma Lisans paketinde derinlik bilgisi bulunmamaktadır.",
      ],
      startDate: [
        {
          label: "Seçiniz",
          code: -1,
        },
        {
          label: "Hemen",
          code: 0,
        },
        {
          label: "Ay Başında",
          code: 1,
        },
      ],
      cusId: null,
    };
  },
  created() {
    this.handleWidth();
    window.addEventListener("resize", this.handleWidth());
  },
  mounted() {
    this.setSelectedForeign([]);
    this.setSelectedAlgoServer([]);
    this.setSelectedResearch([]);
    this.cusId =
      this.$route.params.customerId !== undefined
        ? this.$route.params.customerId
        : null;
    if (this.$route.name === "Checkout") {
      this.cusId =
        this.$route.query.c !== undefined
          ? this.$route.query.c
          : this.$route.params.customerId;
      this.startDateSelection = this.dataItem.dateSelection;
    }
    this.sumFundCommission();
    this.getForeign([
      this.dataItem.application.applicationId,
      this.dataItem.platform.platformId,
      this.cusId,
    ]).then((res) => {
      let details = {};
      details = res.data;
      if (this.getDraftPackageDetails.foreignIndice) {
        this.getDraftPackageDetails.foreignIndice.forEach((element, index) => {
          if (element.foreignIndiceFeature?.id == details[index]?.id) {
            details[index].dateSelection = Number(element.dateSelection.key);
          }
        });
      }

      this.foreign.push({
        id: 2,
        active: false,
        title: "Yabancı Endeksler",
        details,
      });
    });

    this.getResearch([
      this.dataItem.application.applicationId,
      this.cusId,
    ]).then((res) => {
      let details = res.data;

      if (
        this.dataItem.platform.name === "Masaüstü" &&
        this.dataItem.application.name === "Matriks"
      ) {
        details = details.filter((o) => o.name === "Stockkeys");
      }

      if (
        this.dataItem.platform.name === "Mobil" &&
        (this.dataItem.application.name === "Matriks" ||
          this.dataItem.application.name === "Matriks IQ")
      ) {
        details = details.filter((o) => o.name === "Osmanlı Pro");
      }

      if (this.getDraftPackageDetails.research) {
        this.getDraftPackageDetails.research.forEach((element, index) => {
          if (element.researchFeature?.id == details[index]?.id) {
            details[index].dateSelection = Number(element.dateSelection.key);
          }
        });
      }

      this.research = [
        {
          id: 1,
          active: false,
          title: "Araştırma ve Diğer Uygulamalar",
          details,
        },
      ];
    });

    this.getAlgoServer([
      this.dataItem.application.applicationId,
      this.cusId,
    ]).then((res) => {
      let details = {};
      details = res.data;

      // Terminal ürünü her durumda listeden kaldırılmalı.
      const terminalAlgoName = "MATRİKS - Oto Al-Sat - Terminal";
      const idealTerminalName = "İDEAL - Robot Yetkisi - Terminal";

      details = (details || []).filter(
        (element) => (element?.name !== terminalAlgoName && element?.name !== idealTerminalName)
      );

      if (this.getDraftPackageDetails.algorithm) {
        this.getDraftPackageDetails.algorithm.forEach((element, index) => {
          details[index].isChecked = false;
          if (element.algorithmId == 80) {
            details[index].isDisable = true;
            details[index].showNextMonth = false;
          }

          if (element.algorithmFeature.id == details[index]?.id) {
            details[index].dateSelection = Number(element.dateSelection.key);
          }
        });
      }
      details.forEach((element) => {
        element.isChecked = false;
        if (element.algorithmId == 80) {
          element.isDisable = true;
          element.showNextMonth = false;
        }
      });
      this.algoServer.push({
        id: 3,
        active: false,
        title: "Algoritmalar",
        details,
      });
    });
  },
  computed: {
    ...mapGetters([
      "getSelectedAlgoServerInfo",
      "getAlgoServerInfo",
      "customer",
      "getSelectedForeignInfo",
      "getSelectedResearchInfo",
      "getDraftPackageDetails",
      "getPackageInfo",
      "getUserInfo",
    ]),
    getMemberType() {
      return this.getUserInfo.memberType;
    },
    currencySymbol() {
      return CurrencySymbol;
    },
    researchTotal() {
      return this.getSelectedResearchInfo.reduce((totald, item) => {
        return (item?.price || 0) + totald;
      }, 0);
    },
    foraignDollarTotal() {
      return this.getSelectedForeignInfo.reduce((totald, item) => {
        if (item.priceInfo === "$") {
          return (item?.price || 0) + totald;
        } else {
          return 0 + totald;
        }
      }, 0);
    },
    getStartDateSelection() {
      return this.dataItem.dateSelection;
    },
    foraignEuroTotal() {
      return this.getSelectedForeignInfo.reduce((totald, item) => {
        if (item.priceInfo === "€") {
          return (item?.price || 0) + totald;
        } else {
          return 0 + totald;
        }
      }, 0);
    },
    algoServerTotal() {
      return this.getSelectedAlgoServerInfo.reduce((totald, item) => {
        return (item?.price || 0) + totald;
      }, 0);
    },
    researchFund() {
      return this.getSelectedResearchInfo.reduce((totald, item) => {
        return (item?.fundAmount || 0) + totald;
      }, 0);
    },
    foreignFund() {
      return this.getSelectedForeignInfo.reduce((totald, item) => {
        return (item?.fundAmount || 0) + totald;
      }, 0);
    },
    algoServerFund() {
      return this.getSelectedAlgoServerInfo.reduce((totald, item) => {
        return (item?.fundAmount || 0) + totald;
      }, 0);
    },
    researchCommission() {
      return this.getSelectedResearchInfo.reduce((totald, item) => {
        return (item?.commissionAmount || 0) + totald;
      }, 0);
    },
    foreignCommission() {
      return this.getSelectedForeignInfo.reduce((totald, item) => {
        return (item?.commissionAmount || 0) + totald;
      }, 0);
    },
    foraignTurkishLiraTotal() {
      return this.getSelectedForeignInfo.reduce((totald, item) => {
        if (item.priceInfo === "₺") {
          return (item?.price || 0) + totald;
        } else {
          return 0 + totald;
        }
      }, 0);
    },
    algoServerCommission() {
      return this.getSelectedAlgoServerInfo.reduce((totald, item) => {
        return (item?.commissionAmount || 0) + totald;
      }, 0);
    },
    totalPriceDollar() {
      return this.dataItem?.price?.prices?.filter(
        (e) => e.info === this.currencySymbol.dolar
      )[0];
    },
    totalPriceEuro() {
      return this.dataItem?.price?.prices?.filter(
        (e) => e.info === this.currencySymbol.euro
      )[0];
    },
    totalPriceTl() {
      const checkTL = this.dataItem?.price?.prices?.filter(
        (e) => e.info === this.currencySymbol.tl
      )[0];
      return checkTL ? checkTL.totalPrice : null;
    },
    totalPriceCalc() {
      let totalDollar = `${
        this.totalPriceDollar
          ? ` + ${this.formatPriceDollar(
              this.totalPriceDollar?.totalPrice
            )} USD`
          : ""
      }`;
      let totalEuro = `${
        this.totalPriceEuro
          ? ` + ${this.formatPriceEuro(this.totalPriceEuro?.totalPrice)} EUR`
          : ""
      }`;
      return (
        this.formatPrice(this.totalPriceTl) +
        this.currencySymbol.tl +
        totalDollar +
        totalEuro
      );
    },
    showAlgos() {
      return this.marketInfo.filter(
        (o) =>
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Ideal) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Ideal) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Foreks) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Foreks)
      );
    },
    showResearch() {
      return this.marketInfo.filter(
        (o) =>
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.Mobile &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.Mobile &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Ideal) ||
          (o.platformId == this.Products.type.Mobile &&
            o.applicationId == this.Products.name.Ideal) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Ideal)
      );
    },
    showForeign() {
      return this.marketInfo.filter(
        (o) =>
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.Mobile &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Matriks) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.Mobile &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.MatriksIQ) ||
          (o.platformId == this.Products.type.Desktop &&
            o.applicationId == this.Products.name.Foreks) ||
          (o.platformId == this.Products.type.Mobile &&
            o.applicationId == this.Products.name.Foreks) ||
          (o.platformId == this.Products.type.DesktopAndMobile &&
            o.applicationId == this.Products.name.Foreks)
      );
    },
  },
  methods: {
    ...mapActions([
      "getForeign",
      "getAllPackages",
      "getDraftPackageDetail",
      "getResearch",
      "updatePackage",
      "getAlgoServer",
      "createPackage",
    ]),
    ...mapMutations([
      "setSelectedForeign",
      "setSelectedAlgoServer",
      "setSelectedResearch",
      "setIsPurchaseOrUpgradeHappend",
      "setAlgoServer",
    ]),
    checkSpesificWarning(param) {
      this.warningMessage = param;
    },
    setDefaultValues() {
      this.bottomCommission = 0;
      this.totalPrice = 0;
      this.bottomFund = 0;
      this.selectData = [];
      this.startDateSelection = this.startDate[0].code;
      this.setSelectedForeign([]);
      this.setSelectedAlgoServer([]);
      this.setSelectedResearch([]);
      this.updatedList = [];
      this.$emit("close");
    },
    handleWidth() {
      let w = window.innerWidth;
      this.isResponsive = w <= 640;
    },
    sumFundCommission() {
      this.fund = this.dataItem.price.totalFundAmount;
      this.commission = this.dataItem.price.totalCommissionAmount;
      this.topPrice = this.totalPriceCalc;
      this.totalPrice = this.topPrice;
    },
    changeSelected(data) {
      this.selectData = data;
    },
    async submitShow() {
      this.isButtonClicked = true;
      const packageData = this.buildPackageData();
      const getEveryDateSelection = packageData.filter(
        (o) => o.dateSelection == -1
      );
      const getResearchDateSelection = this.getSelectedResearchInfo.filter(
        (o) => o.dateSelection == -1
      );

      const getForeignDateSelection = this.getSelectedForeignInfo.filter(
        (o) => o.dateSelection == -1
      );

      const getSelectedAlgoSvInfo = this.getSelectedAlgoServerInfo.filter(
        (o) => o.dateSelection == -1
      );
      if (
        getEveryDateSelection.length > 0 ||
        getResearchDateSelection.length > 0 ||
        getForeignDateSelection.length > 0 ||
        getSelectedAlgoSvInfo.length > 0
      ) {
        this.$toast.error("Başlangıç zamanı seçiniz.");
        this.isButtonClicked = false;
        return;
      }

      const researchData = this.buildResearchData();
      const foreignData = this.buildForeignData();
      const algoServerData = this.buildAlgoServerData();

      const args = this.buildArgsObject(
        packageData,
        researchData,
        foreignData,
        algoServerData
      );
      const actionName = this.getActionName();
      const sendAction = await this[actionName](args);

      if (sendAction.error) {
        this.handleError(sendAction);
      } else {
        this.handleSuccess(sendAction, actionName);
        this.args = {};
      }
      this.isButtonClicked = false;
    },

    buildPackageData() {
      return this.selectData.map((item) => ({
        applicationId: this.dataItem?.application?.id,
        platformId: this.dataItem?.platform?.id || null,
        marketId: item?.marketFeature?.id || null,
        perspectiveId: item?.perspectiveFeature?.id || null,
        vendorId:
          item?.vendorFeature?.id === undefined ||
          item?.vendorFeature?.id === null
            ? null
            : item?.vendorFeature?.id,
        dateSelection: item.dateSelection,
      }));
    },

    buildResearchData() {
      return this.getSelectedResearchInfo.map((item) => ({
        applicationId: this.dataItem.application.id || null,
        researchId: item.id || null,
        dateSelection: item.dateSelection,
      }));
    },

    buildForeignData() {
      return this.getSelectedForeignInfo.map((item) => ({
        applicationId: this.dataItem.application.id,
        foreignIndiceId: item.id || null,
        dateSelection: item.dateSelection,
      }));
    },

    buildAlgoServerData() {
      return this.getSelectedAlgoServerInfo.map((item) => ({
        applicationId: this.dataItem.application.id,
        algorithmAndServerId: item.id || null,
        dateSelection: item.dateSelection,
      }));
    },

    buildArgsObject(packageData, researchData, foreignData, algoServerData) {
      return {
        customerId: this.customer.id,
        purchaseId: this.dataItem.id,
        purchaseNumber: this.dataItem.purchaseNo.toString(),
        applicationId: this.dataItem?.application?.applicationId || null,
        platformId: this.dataItem?.platform?.platformId || null,
        applicationFeatureId: this.dataItem?.application.id || null,
        platformFeatureId: this.dataItem?.platform?.id,
        features: packageData,
        research: researchData,
        foreignIndice: foreignData,
        algorithmAndServer: algoServerData,
        cusId: this.cusId,
      };
    },

    getActionName() {
      return this.dataItem.packageStatus.id === 2
        ? "updatePackage"
        : "createPackage";
    },

    handleError(res) {
      if (res.result !== undefined && res.result !== null) {
        this.$toast.error(res.result.data[0].errors[0]);
      } else {
        this.$toast.error(res.message);
      }
      this.isButtonClicked = false;
    },

    handleSuccess(res, actionName) {
      if (actionName === "updatePackage") {
        this.handleUpdatePackageSuccess(res);
      } else {
        this.handleCreatePackageSuccess(res);
      }
    },

    async handleUpdatePackageSuccess() {
      this.setIsPurchaseOrUpgradeHappend(true);
      const response = await this.getDraftPackageDetail([
        this.dataItem.id,
        this.cusId,
      ]);
      if (response && this.$route.name != "Checkout") {
        this.$router.push({
          name: "Checkout",
          params: {
            packageNumber: response.data.id,
            customerNumber:
              localStorage.getItem("memberType") == 3
                ? localStorage.getItem("userId")
                : this.$route.params.customerNumber,
          },
          query: {
            c:
              localStorage.getItem("memberType") == 3
                ? localStorage.getItem("userId")
                : this.$route.query.c,
          },
        });
      } else {
        this.$emit("close");
        this.isButtonClicked = false;
      }
    },

    handleCreatePackageSuccess(res) {
      if (this.$route.name === "Checkout") {
        this.$router.replace({
          params: {
            packageNumber: String(res.purchaseId),
            customerNumber: this.$route.params.customerNumber,
          },
          query: { c: this.$route.query.c },
        });
        setTimeout(() => {
          this.$emit("close");
        }, 300);
      } else {
        this.$emit("close");
        this.getAllPackages(this.cusId);
      }

      this.setSelectedResearch([]);
      this.setSelectedForeign([]);
      this.setSelectedAlgoServer([]);
    },
    calculatePrice(items) {
      this.bottomFund = items.reduce((totald, item) => {
        return (
          (item?.marketFeature?.fundAmount || 0) +
          (item?.perspectiveFeature?.fundAmount || 0) +
          (item?.vendorFeature?.fundAmount || 0) +
          totald
        );
      }, this.dataItem.application?.fundAmount);

      this.bottomCommission = items.reduce((totald, item) => {
        return (
          (item?.marketFeature?.commissionAmount || 0) +
          (item?.perspectiveFeature?.commissionAmount || 0) +
          (item?.vendorFeature?.commissionAmount || 0) +
          totald
        );
      }, this.dataItem.application?.commissionAmount);

      const total = items.reduce((totald, item) => {
        return (
          /* (item?.marketFeature?.price || 0) +
          (item?.platformFeature?.price || 0)*/ +(
            item?.perspectiveFeature?.price || 0
          ) +
          (item?.vendorFeature?.price || 0) +
          totald
        );
      }, 0);
      this.totalPrice = total + this.dataItem.application.price;
    },
    calculateTotalPrice() {
      return (
        this.dataItem.price +
        this.totalPrice +
        this.researchTotal() +
        this.foraignTurkishLiraTotal() +
        this.algoServerTotal()
      );
    },
    setPropsForAlgoServer(checkedDataListFromChildren) {
      let data = [checkedDataListFromChildren];
      let updatedDetails = [...data];
      const item = checkedDataListFromChildren;
      this.algoServer[0].details.forEach((detail) => {
        if (!data.some((item) => item.algorithmId === detail.algorithmId)) {
          updatedDetails.push(detail);
        }
      });
      const algoId5 = updatedDetails.find((item) => item.algorithmId === 5);
      const grid = updatedDetails.find((item) => item.algorithmId === 80);
      const gridIndex = updatedDetails.findIndex(
        (item) => item.algorithmId === 80
      );

      if (!algoId5.isChecked) {
        updatedDetails[gridIndex].isDisable = true;

        if (grid.isChecked) {
          updatedDetails[gridIndex].isChecked = false;
        }
      } else {
        if (algoId5.dateSelection == 1) {
          updatedDetails[gridIndex].dateSelection = 1;
          updatedDetails[gridIndex].showNextMonth = true;
        } else {
          updatedDetails[gridIndex].showNextMonth = false;
          if (item.algorithmId == 80) {
            if (item.dateSelection == undefined) {
              updatedDetails[gridIndex].dateSelection = -1;
            } else {
              updatedDetails[gridIndex].dateSelection = item.dateSelection;
            }
          } else {
            //burası 6 olabilir o yüzden kontrol eklendi.
            if (checkedDataListFromChildren.algorithmId != 6) {
              if (item.algorithmId == 80) {
                updatedDetails[gridIndex].dateSelection =
                  item.dateSelection != -1 ? item.dateSelection : -1;
              }
            }
          }
        }
        if (grid) {
          updatedDetails[gridIndex].isDisable = algoId5.isChecked
            ? false
            : true;
        }
      }

      const index = this.updatedList.findIndex(
        (existingItem) => existingItem.id === item.id
      );
      if (item.isChecked) {
        if (index === -1) {
          this.updatedList.push(item);
          if (item.algorithmId == 5 && grid) {
            if (
              this.getDraftPackageDetails.algorithm != undefined &&
              this.$route.name == "Checkout"
            ) {
              let isGridChecked = false;
              this.getDraftPackageDetails.algorithm.forEach((el) => {
                if (el.algorithmFeature.algorithmId == 80) {
                  grid.isChecked = true;
                  grid.isDisable = false;
                  isGridChecked = true;
                  grid.dateSelection = Number(el.dateSelection.key);
                }
              });
              if (isGridChecked) {
                this.updatedList.push(grid);
              }
            }
            if (
              this.getPackageInfo.algorithm != undefined &&
              this.$route.name != "Checkout"
            ) {
              let isGridChecked = false;
              this.getPackageInfo.algorithm.forEach((el) => {
                if (el.algorithmFeature.algorithmId == 80) {
                  grid.isChecked = true;
                  grid.isDisable = false;
                  isGridChecked = true;
                  grid.dateSelection = Number(el.dateSelection.key);
                }
              });
              if (isGridChecked) {
                this.updatedList.push(grid);
              }
            }
          }
        } else {
          this.updatedList[index] = item;
        }
      } else {
        if (index !== -1) {
          this.updatedList.splice(index, 1);
          const grid = this.updatedList.findIndex(
            (item) => item.algorithmId === 80
          );
          if (grid != -1 && item.algorithmId != 6) {
            this.updatedList.splice(grid, 1);
          }
        }
      }
      const list = [6, 5, 80];
      updatedDetails.sort(
        (a, b) => list.indexOf(a.algorithmId) - list.indexOf(b.algorithmId)
      );

      this.algoServer[0].details = updatedDetails;
      this.setSelectedAlgoServer(this.updatedList);
    },
  },
  watch: {
    selectData: {
      handler(newVal) {
        this.calculatePrice(newVal);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.osm-vd {
  .veri-dagitim-selectbox.v-select {
    overflow-y: scroll;
  }
  .m-flex {
    display: flex;
  }
  .m-items-center {
    align-items: center;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  .text-center {
    text-align: center;
  }
  .warning-messages {
    background-color: #fff3cd;
    min-height: 40px;
    display: flex;
    align-items: center;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0px 0px 3px #000;
    margin-bottom: 20px;
    max-width: 80%;
    margin-left: 5px;
    @media (max-width: 585px) {
      display: block;
      text-align: center;
    }
    .error-icon {
      border-radius: 100%;
      border: 1px solid #000;
      color: #000;
      font-weight: bold;
      width: 30px;
      display: inline-flex;
      justify-content: center;
      height: 30px;
      align-items: center;
      font-size: 24px !important;
      margin-right: 10px;
      @media (max-width: 585px) {
        display: block;
        margin: 0 auto;
      }
    }
  }
  .package-settings {
    overflow: auto;
    @media (min-width: 640px) {
      height: calc(100vh - 250px);
    }

    &__info {
      h3 {
        font-size: 16px;
        font-weight: 600;
      }
      span {
        font-size: 14px;
      }
    }
    &__info-platform {
      font-size: 16px;
    }
    &__info_price {
      font-size: 29px;
      font-weight: bold;
      margin-top: 12px;
    }
    &__info_bes,
    &__info_bes span {
      font-size: 14px;
    }
    &__image img {
      margin-right: 20px;
      width: 80px;
      object-fit: contain;
    }
    &__top {
      margin-bottom: 30px;
    }
    &__lisans {
      overflow-y: auto;
      &__information {
        padding: 20px;
        background: var(--grayscale-0);
        margin-bottom: 20px;
        @media (max-width: 768px) {
          border-radius: 4px;
          padding: 12px;
        }

        h5 {
          font-size: 14px;
          font-weight: 600;
          @media (max-width: 768px) {
            border-bottom: 1px solid var(--color-primary-tint-second);
            margin: auto -12px 16px -12px;
            padding: 0px 12px 13px 12px;
          }
        }
        .table {
          margin-bottom: 0px !important;
        }
      }
      @media (max-width: 898px) {
        overflow: auto;
      }
      .table {
        border-collapse: collapse;
        text-indent: 0;
        min-width: 100%;
        border-radius: var(--radius-second) !important;
        overflow: auto;
        border: solid 1px var(--color-primary-tint-second);
        background-color: #fff;
        margin: 20px 0px;
        overflow-y: visible !important;

        ::v-deep th {
          background: var(--grayscale-160);
          height: 40px;
          font-weight: 600 !important;
        }

        ::v-deep th,
        ::v-deep td {
          font-size: 12px;
          vertical-align: middle;
          border-top: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
          font-weight: 500 !important;

          .option {
            .veri-dagitim-selectbox.v-select {
              border: 1px solid transparent;
              width: 100%;

              .vs {
                &__dropdown-toggle {
                  padding: 0px;
                  border: 0px !important;
                  position: relative;

                  &:focus-visible {
                    outline: none !important;
                  }

                  svg {
                    display: block !important;
                  }
                }

                &__selected {
                  padding: 0;
                  margin: 0;

                  &-options {
                    padding: 0px !important;
                    position: relative;
                  }
                }

                &__clear {
                  display: none !important;
                }

                &__actions {
                  padding: 0px;
                  cursor: pointer !important;
                  background: transparent !important;
                }
              }

              &__search,
              &__search:focus {
                border: none !important;
              }
            }

            .editing-view-port {
              display: none !important;
            }
          }
        }
        ::v-deep tbody {
          tr:nth-child(2n) {
            background: var(--color-primary-zebra);
          }
          tr td {
            height: 26px;
            color: var(--grayscale-200);

            &:nth-child(2) {
              width: 110px;
              padding: 18px 0px;
              .paranthesis {
                font-size: 11px;
              }
            }

            &:nth-child(3),
            &:nth-child(4) {
              min-width: 252px;
            }
          }
          tr td:first-child {
            width: 38px;
            padding: 0px;
            padding-right: 6px;
            text-align: right;
            border-left: 1px solid #e8e8e8;
          }

          td:last-child {
            width: 150px;
            padding-right: 20px;
            .veri-dagitim-selectbox.v-select {
              .vs__dropdown-toggle {
                min-width: auto;
                font-size: 14px;
              }
              .vs__search {
                display: none;
              }
            }
          }
        }
      }
      ::v-deep .setHeight tbody tr td {
        height: 64px !important;
      }

      .info-option {
        display: flex;
        align-items: center;
        justify-content: left;
        svg {
          cursor: pointer;
        }
      }
      .accordion-container {
        width: 100%;
      }
    }
    @media (max-width: 640px) {
      &__bottom-right {
        text-align: center;
      }
    }
    &__bottom {
      width: 100%;
      padding: 20px 0px 8px 0px;
      border-top: 1px solid var(--grayscale-30);
      justify-content: space-between;
      background-color: var(--grayscale-10);

      &-left {
        display: flex;
      }
      @media (max-width: 640px) {
        position: relative;
        flex-flow: column;
      }
      ::v-deep .form-group {
        position: relative;
        margin-right: 16px;
        width: 100%;
      }
      ::v-deep .form-control-label {
        font-size: 12px;
        color: var(--grayscale-70);
        position: absolute;
        padding: 0 7px;
        margin-left: 10px;
        z-index: 2;
        top: -5px;
      }
    }
    &__bottom-right {
      line-height: 24px;
      @media (max-width: 640px) {
        text-align: left;
        margin-bottom: 0px;
        width: 100%;
      }
      ::v-deep p,
      ::v-deep span {
        font-size: 14px;
        font-weight: 600;
        color: var(--grayscale-120);
      }
      ::v-deep p {
        color: var(--color-primary-black-metallic);
      }
    }
    @media (max-width: 640px) {
      &__bottom-left {
        width: 100%;
        flex-direction: column;
      }
    }

    &__bottom-action {
      width: 216px;
      margin-left: 40px;
      @media (max-width: 640px) {
        width: 100%;
        align-items: inherit;
        flex-flow: column;
        margin-left: auto;
        .start-date-select {
          width: 100%;
          margin-bottom: 10px;
        }
      }
    }
    &__price {
      align-items: center;
      justify-content: center;
      font-weight: 600;
      @media (max-width: 640px) {
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 15px;
      }
      span {
        font-size: 14px;
        color: var(--grayscale-120);
      }
      h2 {
        font-size: 14px;
        color: var(--color-primary-black-metallic);
        margin-left: 5px;
      }
    }
    .up svg {
      color: #28a745;
    }
    .down svg {
      color: #dc3545;
    }
    .warning-area {
      margin-bottom: 2em;
      .row-area {
        border: 1px solid var(--grayscale-30);
        border-radius: var(--radius-second);
        margin-top: 1em;
        .row {
          padding: 15px;
          display: flex;
          align-items: center;
          .icon-area {
            margin-right: 10px;
          }
          &:nth-child(odd) {
            background-color: var(--grayscale-0);
          }
        }
      }
    }
    .terminal-area {
      padding: 20px 0;
      margin-bottom: 1em;
      .text {
        margin-bottom: 1em;
      }
    }
  }

  @media (max-width: 640px) {
    .info-container {
      position: relative;
      margin-top: 20px;
    }
  }
  .market-table {
    width: 100%;
    display: block;
    border-radius: 16px;
  }
  .market-table-responsive {
    width: 100%;
    display: none;
  }
  @media (max-width: 640px) {
    .info-container {
      position: relative;
      margin-top: 20px;
    }
    .market-table {
      display: none;
    }
    .market-table-responsive {
      display: block;
    }
  }
  @media (max-width: 389px) {
    .info-container {
      margin-top: 8px;
    }
  }
}
</style>
